import { IconProps } from "@/components/Icons/index";

export const MasterCardIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    {...props}
  >
    <path
      d="M13.9678 3.85481H8.01428V14.1454H13.9678V3.85481Z"
      fill="#FF5A00"
      style={{ fill: "#FF5A00", fillOpacity: "1" }}
    />
    <path
      d="M8.41073 9C8.41073 6.90927 9.43235 5.05366 11 3.85472C9.84628 2.98199 8.39091 2.45454 6.80344 2.45454C3.04283 2.45454 0 5.38199 0 9C0 12.618 3.04283 15.5455 6.80344 15.5455C8.39091 15.5455 9.84628 15.018 11 14.1453C9.43014 12.9633 8.41073 11.0907 8.41073 9Z"
      fill="#EB001B"
      style={{ fill: "#EB001B", fillOpacity: "1" }}
    />
    <path
      d="M22 9C22 12.618 18.9572 15.5455 15.1966 15.5455C13.6091 15.5455 12.1537 15.018 11 14.1453C12.5875 12.9442 13.5893 11.0907 13.5893 9C13.5893 6.90927 12.5677 5.05366 11 3.85472C12.1515 2.98199 13.6069 2.45454 15.1944 2.45454C18.9572 2.45454 22 5.40106 22 9Z"
      fill="#F79E1B"
      style={{ fill: "#F79E1B", fillOpacity: "1" }}
    />
  </svg>
);
